import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {};
__decorate([Prop({
  required: true
})], default_1.prototype, "image", void 0);
__decorate([Prop({
  default: '150px'
})], default_1.prototype, "width", void 0);
__decorate([Prop({
  default: '150px'
})], default_1.prototype, "height", void 0);
__decorate([Prop({
  default: 1
})], default_1.prototype, "zIndex", void 0);
default_1 = __decorate([Component({
  name: 'PanThumb'
})], default_1);
export default default_1;